import template from './sw-cms-el-preview-acris-blog-image-slider.html.twig';
import './sw-cms-el-preview-acris-blog-image-slider.scss';

const { Component } = Shopware;

Component.register('sw-cms-el-preview-acris-blog-image-slider', {
    template,

    computed: {
        assetFilter() {
            return Shopware.Filter.getByName('asset');
        },
    }
});